import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=9a0b4a5a&"
import script from "./Route.vue?vue&type=script&lang=js&"
export * from "./Route.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports